import axios from "axios";
import { getUserFromLS } from "../utils/getUserFromLS";
import { ICadenceTemplateSummary } from "../Types/socialPromptCadenceTemplate";

/** List the current user's saved cadence templates (sorted `updated_at` desc by backend). */
export const getSocialPromptCadenceTemplates = async (): Promise<ICadenceTemplateSummary[]> => {
  const user = getUserFromLS();
  const URL = `${import.meta.env.VITE_API_BASE_URL}/social-prompt-cadence-templates/`;

  const response = await axios.get<ICadenceTemplateSummary[]>(URL, {
    headers: {
      Authorization: `Bearer ${user.access_token}`,
    },
  });

  return response.data;
};
